/**
 * Hero Knob — the single expressive control. One normalized 0..1 value (ENG-009).
 * Inert until the Realm is active; the ring is unlit while inert (ENG-037).
 */
import type { Ctx } from '../core/machine';
import { HERO_FORCE_LABEL } from '../core/constants';

export function mountHeroKnob(
  parent: HTMLElement,
  onChange: (v: number) => void
): (c: Ctx, live: boolean) => void {
  const wrap = document.createElement('div');
  wrap.className = 'cc-knob';

  const input = document.createElement('input');
  input.type = 'range';
  input.min = '0';
  input.max = '1';
  input.step = '0.001';
  input.value = '0';
  input.className = 'cc-knob-input';
  input.setAttribute('aria-label', HERO_FORCE_LABEL);

  const label = document.createElement('div');
  label.className = 'cc-knob-label';
  label.textContent = HERO_FORCE_LABEL;

  wrap.append(input, label);
  parent.append(wrap);

  input.addEventListener('input', () => onChange(Number(input.value)));

  return (c: Ctx, live: boolean): void => {
    input.disabled = !live;
    wrap.classList.toggle('is-live', live);
    // Ring fill is the value, code-driven — never frame-swapped art.
    wrap.style.setProperty('--fill', String(c.drift));
    if (Number(input.value) !== c.drift) input.value = String(c.drift);
  };
}
